import type { App, Component } from "vue";

const modules = import.meta.glob<Module>(["./*.vue", "./icons/*.vue"], {
  eager: true,
});
const cmps = Object.keys(modules).reduce<Record<string, Component>>(
  (components, path) => {
    const module = modules[path]!;
    let name = path.split("/").pop();
    if (name !== undefined) {
      name = name.replace(/\.\w+$/, "");
      components[name] = module.default;
    }
    return components;
  },
  {}
);

export default {
  install: (app: App): void => {
    for (const [key, component] of Object.entries(cmps)) {
      app.component(key, component);
    }
  },
};
